// extracted by mini-css-extract-plugin
module.exports = {"icon":"column-status_icon__3d2B-","tooltipError":"column-status_tooltipError__17EuE"};